module.exports = __webpack_public_path__ + "img/logo111092.7f4e49ff.png";